import React, { FunctionComponent, useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import clsx from "clsx";
import _isEmpty from "lodash/isEmpty";
import _isNumber from "lodash/isNumber";
import useGlobalContext from "../Context/useGlobalContext";
import config from "../config.json";

const backgroundColor = config.backgroundColor;

const FilterBody = ({ onClose, children, minWidth }) => {
  const styles = useStyles();
  return (
    <Card className={clsx(styles.cardWrapper)} style={{ width: minWidth }}>
      <CardContent className={styles.contentContainer}>
        <div className={styles.closeIconWrapper}>
          <IconButton onClick={onClose} className={styles.closeIconButton}>
            <CloseIcon />
          </IconButton>
        </div>
        {children}
      </CardContent>
    </Card>
  );
};

interface Props {
  onClose: () => void;
  minWidth: string;
}

const FlightSearch: FunctionComponent<Props> = ({ onClose, minWidth }) => {
  const {
    setSearchFlightData,
    viewPort,
    setViewPort,
    showSnackBar,
    flightFeatureCollection,
  } = useGlobalContext();
  const [flightSearchText, setFlightSearchText] = useState("");

  const styles = useStyles();

  const onClearClick = () => {
    setFlightSearchText("");
    setSearchFlightData("");
  };

  const onTagClick = () => {
    // console.log('ffff', flightSearchText, flightFeatureCollection);
    
    const searchedFlight = flightFeatureCollection.features.find(
      (item) => item.properties.aid === flightSearchText || item.properties.tail === flightSearchText 
    );
    if (searchedFlight) {
      setViewPort({
        ...viewPort,
        latitude: searchedFlight.properties.lat,
        longitude: searchedFlight.properties.long,
      });
      setSearchFlightData(flightSearchText);
    } else {
      showSnackBar("No Flights Found");
    }
  };
  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      onTagClick();
    }
  };

  const onFlightNameChange = (event) => {
    const searchData = event.target.value.toLocaleUpperCase();
    setFlightSearchText(searchData);
  };

  return (
    <FilterBody onClose={onClose} minWidth={minWidth}>
      <div>
        <Typography className={styles.searchHintText}>
          TYPE TARGET NAME
        </Typography>
        <Input
          autoComplete={"off"}
          className={clsx(styles.inputBoxDefaults, styles.searchInput)}
          name={"searchFlightInput"}
          value={flightSearchText}
          onChange={onFlightNameChange}
          onKeyUp={onKeyPress}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={onTagClick}
          className={styles.buttonContainer}
        >
          TAG
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClearClick}
          className={styles.buttonContainer}
        >
          CLR
        </Button>
      </div>
    </FilterBody>
  );
};

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    // container: {
    //   width: '290px',
    // },
    cardWrapper: {
      borderRadius: "0px 5px 5px 0px",
      height: "fit-content",
      padding: "12px",
    },
    buttonAlign: {
      marginLeft: "257px",
    },
    closeIconButton: {
      marginTop: "-10px",
      padding: "0px 8px 8px 8px",
      backgroundColor: "transparent !important",
      "& svg": {
        width: "14px",
        height: "14px",
      },
    },
    contentContainer: {
      padding: "10px !important",
      borderRadius: "5px",
      display: "flex",
      flexDirection: "row-reverse",
      justifyContent: "space-between",
      backgroundColor: theme.palette.background.default,
    },
    iconButton: {
      height: "30px",
      width: "30px",
      "& svg": {
        width: "15px",
        height: "15px",
      },
    },
    searchHintText: {
      fontSize: "10px",
      fontWeight: 500,
    },
    buttonContainer: {
      minWidth: "40px",
      height: "25px",
      borderRadius: "5px",
      fontSize: "13px",
      letterSpacing: "0.5px",
      fontWeight: 600,
      padding: "0px 0px 0px 0px !important",
      marginLeft: "9px",
    },
    resetButton: {
      width: "62px",
    },
    closeIconWrapper: {
      width: "7%",
    },
    inputBoxDefaults: {
      fontWeight: 500,
      fontSize: "15px",
      "& .MuiInputBase-input": {
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        backgroundColor: "transparent !important",
      },
      "-webkit-appearance": "textfield",
      "-moz-appearance": "textfield",
    },
    searchInput: {
      width: "150px",
    },
    filterInput: {
      width: "65px",
    },
  });
});

export default FlightSearch;
